<template>
  <ValidationObserver
    ref="MessageTemplatesObserver"
    v-slot="{ valid, pristine, errors }" >
    <b-modal
      id="add-new-block-modal"
      ref="addNewBlockModal"
      modal-class="settings-modal"
      :body-class="['body-wrapper', {'white-bg': !selectedBlock}]"
      :hide-footer="!selectedBlock"
      hide-header-close
      size="md"
      centered
      @hidden="clear">

      <template #modal-header>
        <div
          v-if="selectedBlock && !editMessage"
          class="modal-title m-0 header-btn"
          @click="resetBlockType" >
          <SBIcon
            :icon="SBIconList.DOWN_ARROW"
            :color="SBColors.greyPrimary"
            :size="11" />
          {{ title }}
        </div>
        <div v-else-if="editMessage">{{ title | editMode }}</div>
        <div v-else>{{ title }}</div>
      </template>

      <!-- Default view -->
      <template v-if="!selectedBlock">
        <!-- Content blocks -->
        <h5 v-if="contentBlocks.length">Content</h5>
        <div
          v-if="contentBlocks.length"
          class="row blocks">
          <div
            v-for="(block, index) in contentBlocks"
            :key="index"
            class="col-6 block"
            @click="showBlock(block)" >
            <SBIcon
              :icon="block.icon"
              :color="SBColors.greyPrimary"
              :size="block.iconSize" />
            {{ block.text }}
          </div>
        </div>

        <!-- Activity blocks -->
        <h5 v-if="activityBlocks.length">Activity</h5>
        <div
          v-if="activityBlocks.length"
          class="row blocks">
          <div
            v-for="(block, index) in activityBlocks"
            :key="index"
            class="col-6 block"
            @click="showBlock(block)" >
            <SBIcon
              :icon="block.icon"
              :color="SBColors.greyPrimary"
              :size="block.iconSize" />
            {{ block.text }}
          </div>
        </div>
      </template>

      <!-- Send text view -->
      <template v-if="selectedBlock && selectedBlock.blockType === 'text'">
        <ValidationProvider
          v-slot="{ errors }"
          ref="messageValidationProviderRef"
          name="Message"
          rules="required">
          <b-form-group>
            <label
              for="text-field"
              class="settings__label mt-0 flex flex-align-center" >
              <p class="greedy">Message</p>
              <!-- <span class="character-counter">{{ maxMessageTextLength - sendTextContent.length }}</span> -->
            </label>
            <SBTextInput
              id="text-field"
              ref="messageArea"
              v-model="sendTextContent"
              :maxlength="0"
              :focus-shadow="true"
              :business-id="businessId"
              :show-tags-select="true"
              placeholder="Enter message..." />
          </b-form-group>
          <div
            v-if="errors[0]"
            class="error flex flex-align-center">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </template>

      <!-- Send file view -->
      <template v-if="selectedBlock && selectedBlock.blockType === 'file'">
        <ValidationProvider
          v-slot="{ errors }"
          ref="fileValidationProviderRef"
          name="File"
          :rules="editMessage ? '' : 'required'">
          <b-form-group>
            <label
              for="file-field"
              class="settings__label mt-0" >
              {{ editMessage ? 'New file' : 'File' }}
            </label>
            <!-- :extensions="whatsAppAllowedMediaList" -->
            <DropZone
              ref="dropZone"
              v-model="files"
              @dropped-in="fileDropped"/>
            <!-- :extensions="allowedTemplateMessageAttachments(selectedTemplateLanguageVersion.attachment)" -->
          </b-form-group>
          <div
            v-if="errors[0]"
            class="error flex flex-align-center">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
        <ValidationProvider
          v-if="captionsAllowed"
          v-slot="{ errors }"
          ref="captionValidationProviderRef"
          name="Caption"
          :rules="{
            required: !!buttonType && !!buttonType.code,
          }">
          <b-form-group>
            <label
              for="caption-field"
              class="settings__label" >
              Caption
            </label>
            <SBTextInput
              id="caption-field"
              ref="captionsArea"
              v-model="fileCaptionContent"
              :focus-shadow="true"
              :business-id="businessId"
              :show-tags-select="true"
              placeholder="Add caption..." />
          </b-form-group>
          <div
            v-if="errors[0]"
            class="error flex flex-align-center">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            <span>{{ errors[0] }}</span>
          </div>
        </ValidationProvider>

        <div
          v-if="fileErrorMessage"
          class="error flex center-all">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ fileErrorMessage }}</span>
        </div>
      </template>

      <template
        v-if="
          selectedBlock &&
            (
              selectedBlock.blockType === 'text' ||
              (selectedBlock.blockType === 'file' && files && files[0])
            )
        ">
        <ValidationProvider
          v-slot="{ errors }"
          name="buttons"
          rules="required">
          <b-form-group>
            <label
              for="p-key"
              class="settings__label flex flex-align-center" >
              Interactive buttons
              <!-- <SBIcon
                id="buttons-description"
                class="ml-1"
                :icon="SBIconList.INFORMATION"
                :color="SBColors.greyPrimary"
                :size="12" /> -->
            </label>
            <div id="attachment-wrapper">
              <multiselect
                v-model="buttonType"
                placeholder="Select an option"
                class="flex-options hide-tags no-selected-background"
                :options="buttonTypes"
                label="name"
                track-by="code"
                :multiple="false"
                :show-labels="false"
                :show-no-results="false"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="false"
                :preselect-first="true"
                :searchable="false" >
                <template
                  slot="option"
                  slot-scope="props">
                  <p>{{ props.option.name }}</p>
                </template>
              </multiselect>
            </div>
            <div
              v-if="errors[0]"
              class="error flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.ERROR"
                :color="SBColors.redPrimary"
                :size="12" />
              <span>{{ errors[0] }}</span>
            </div>
            <b-popover
              target="buttons-description"
              triggers="hover"
              placement="bottom">
              <h1>Interactive buttons</h1>
              <p>Create buttons that let customers respond to your message or take action.</p>
            </b-popover>
            <p
              v-if="buttonType && buttonType.code === 'buttons'"
              class="button-description" >Create up to 3 buttons that let customers respond to your message or take action.</p>
            <p
              v-if="buttonType && buttonType.code === 'menu'"
              class="button-description" >Create a menu of up to 10 buttons that let customers respond to your message or take action.</p>
          </b-form-group>
        </ValidationProvider>

        <template v-if="buttonType && buttonType.code === 'buttons'">
          <div
            v-for="(button, index) in buttons"
            :key="index"
            class="button-fields" >
            <ValidationProvider
              v-slot="{ errors, failedRules }"
              :name="`button-${index}`"
              :rules="{
                required: true,
                noDuplicate: {
                  list: butonTitles.filter((bt, bi) => bi !== index),
                  caseSensitive: false,
                  message: 'Each button must have a unique title.'
                }
              }"
              :custom-messages="{required: 'Button title is required.'}">
              <b-form-group>
                <label
                  :for="`buttonInput-${index}`"
                  class="settings__label flex flex-align-center" >
                  <span class="greedy">Button title</span>
                  <span class="character-counter">{{ buttonMaxTextLength - button.value.length }}</span>
                </label>
                <div class="option">
                  <input
                    :id="`buttonInput-${index}`"
                    :ref="`buttonInputRef-${index}`"
                    v-model="button.value"
                    :maxlength="buttonMaxTextLength"
                    type="text"
                    class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                    placeholder="Enter button title" >
                  <SBIcon
                    v-if="buttons.length > 1"
                    class="mr-2 delete"
                    :icon="SBIconList.CLOSE_THIN"
                    :size="10"
                    :hover-size="20"
                    :color="SBColors.greyPrimary"
                    :background-color="SBColors.white"
                    :hover-icon-color="SBColors.blackPrimary"
                    @click="removeOption(index)" />
                </div>
                <div
                  v-if="errors[0] && !failedRules.noDuplicate"
                  class="error flex flex-align-center">
                  <SBIcon
                    class="mr-2"
                    :icon="SBIconList.ERROR"
                    :color="SBColors.redPrimary"
                    :size="12" />
                  <span>{{ errors[0] }}</span>
                </div>
              </b-form-group>
            </ValidationProvider>
          </div>

          <div
            v-if="buttons.length < 3"
            class="add-more-btn"
            @click="addNewButtons">
            <span class="flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.PLUS"
                :color="SBColors.bluePrimary"
                :size="8" />
              <span>Add button</span>
            </span>
          </div>

          <div
            v-if="testButtonsTitleError"
            class="error-message left fs-14 mt-3 flex flex-align-center px-0" >
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            {{ testButtonsTitleError }}
          </div>
        </template>

        <template v-if="buttonType && buttonType.code === 'menu'">
          <ValidationProvider
            v-slot="{ errors }"
            name="Menu title"
            rules="required">
            <b-form-group>
              <label
                for="menu-button-title"
                class="settings__label flex flex-align-center" >
                <span class="greedy">Menu title</span>
                <span class="character-counter">{{ menuItemMaxTextLength - menubuttonTitle.length }}</span>
              </label>
              <div class="option">
                <input
                  id="menu-button-title"
                  v-model="menubuttonTitle"
                  :maxlength="buttonMaxTextLength"
                  type="text"
                  class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                  placeholder="Enter menu title text" >
              </div>
            </b-form-group>
            <div
              v-if="errors[0]"
              class="error flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.ERROR"
                :color="SBColors.redPrimary"
                :size="12" />
              <span>Menu title text is required.</span>
            </div>
          </ValidationProvider>
          <div
            v-for="(menuItem, index) in menuItems"
            :key="index"
            class="button-fields" >
            <ValidationProvider
              v-slot="{ errors, failedRules }"
              :name="`button-${index}`"
              :rules="{
                required: true,
                noDuplicate: {
                  list: menuTitles.filter((mt, mi) => mi !== index),
                  caseSensitive: false,
                  message: 'Each menu item must have a unique title.'
                }
              }" >
              <b-form-group>
                <label
                  :for="`menuItemInput-${index}`"
                  class="settings__label flex flex-align-center" >
                  <span class="greedy">Menu item</span>
                  <span class="character-counter">{{ menuItemMaxTextLength - menuItem.value.length }}</span>
                </label>
                <div class="option">
                  <input
                    :id="`menuItemInput-${index}`"
                    :ref="`menuItemInputRef-${index}`"
                    v-model="menuItem.value"
                    :maxlength="menuItemMaxTextLength"
                    type="text"
                    class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                    placeholder="Enter menu item text" >
                  <SBIcon
                    v-if="menuItems.length > 1"
                    class="mr-2 delete"
                    :icon="SBIconList.CLOSE_THIN"
                    :size="10"
                    :hover-size="20"
                    :color="SBColors.greyPrimary"
                    :background-color="SBColors.white"
                    :hover-icon-color="SBColors.blackPrimary"
                    @click="removeMenuItem(index)" />
                </div>
                <div
                  v-if="errors[0] && !failedRules.noDuplicate"
                  class="error flex flex-align-center">
                  <SBIcon
                    class="mr-2"
                    :icon="SBIconList.ERROR"
                    :color="SBColors.redPrimary"
                    :size="12" />
                  <span>Menu item title is required.</span>
                </div>
              </b-form-group>
            </ValidationProvider>
          </div>

          <div
            v-if="(menuItems.length < 10)"
            class="add-more-btn"
            @click="addNewMenuItem">
            <span class="flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.PLUS"
                :color="SBColors.bluePrimary"
                :size="8" />
              <span>Add menu item</span>
            </span>
          </div>

          <div
            v-if="testMenuTitleError"
            class="error-message left fs-14 mt-3 flex flex-align-center px-0" >
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            {{ testMenuTitleError }}
          </div>
        </template>
      </template>

      <!-- <div
        v-if="$refs.MessageTemplatesObserver && Object.keys($refs.MessageTemplatesObserver.errors).find(e => e.startsWith('button-') && $refs.MessageTemplatesObserver.errors[e].length)"
        class="error flex flex-align-center observer-error">
        <SBIcon
          class="mr-2"
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="12" />
        <span>{{ buttonType.code === 'menu' ? 'Menu items' : 'Buttons' }} must be populated</span>
      </div> -->

      <template
        slot="modal-footer">
        <b-button
          :disabled="loading"
          @click="hide">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="loading || !valid || pristine"
          :class="{loading: loading}"
          class="flex settings__actions--save"
          @click="submit">
          <span>Save</span>
          <Spinner
            v-if="loading"
            :size="14"
            :thickness="2"
            :color="SBColors.white" />
        </b-button>
      </template>

    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

import randomString from '@/helpers/randomString';
import setValidationErrors from '@/helpers/validationErrors';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBTextInput from '@/components/business/widgets/SBTextInput';
import DropZone from '@/components/common/DropZone';
import Spinner from '@/components/common/Spinner';
import { whatsappFormatMessage } from '@/helpers/stringHelpers';
import { allowedTemplateMessageAttachments, getMediaType } from '@/helpers/mediaHelpers';
import { whatsAppAllowedMediaList } from '@/helpers/lists/whatsappAllowedMediaFiles';
import DotSeparator from '@/components/common/DotSeparator';
import { findDeletedCustomFelds } from '@/helpers/quickRepliesParser';

export default {
  name: 'AddNewBlockModal',
  components: {
    SBIcon,
    SBTextInput,
    DropZone,
    Spinner,
    DotSeparator,
    Multiselect,
  },
  props: {
    hideBlocks: {
      type: Array,
      required: false,
      default: () => [],
    },
    businessId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      errorMessage: '',
      validationErrors: {},
      hideFooter: true,
      selectedBlock: null,
      blocks: [
        {
          icon: SBIconList.MESSAGE_BALLOON,
          iconSize: 18,
          text: 'Send text',
          action: this.addSendText,
          group: 'content',
          blockType: 'text',
          hasForm: true,
        },
        {
          icon: SBIconList.IMAGE,
          iconSize: 18,
          text: 'Send file',
          action: this.addSendFile,
          group: 'content',
          blockType: 'file',
          hasForm: true,
        },
        {
          icon: SBIconList.REPLY,
          iconSize: 18,
          text: 'Contact reply',
          action: this.addContactReply,
          group: 'activity',
          blockType: 'reply',
          hasForm: false,
        },
      ],
      files: [],
      fileErrorMessage: null,
      formData: new FormData(),
      captionsAllowed: true,
      fileCaptionContent: '',
      sendTextContent: '',
      buttonType: null,
      editReplyId: null,
      editMessage: null,
      loading: false,
      menubuttonTitle: 'Options',
      buttons: [],
      buttonMaxTextLength: 20,
      menuItems: [],
      menuItemMaxTextLength: 24,
      whatsAppAllowedMediaList,
      maxMessageTextLength: 1024,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      uploadedFile: 'automation/uploadedFile',
      fileUploadError: 'automation/fileUploadError',
      apiError: 'contact/apiError',
      waSettings: 'system/waSettings',
      customFieldChange: 'contact/customFieldChange',
    }),
    butonTitles() {
      return this.buttons.map(b => b.value);
    },
    menuTitles() {
      return this.menuItems.map(m => m.value);
    },
    buttonErrors() {
      if (!this.$refs.MessageTemplatesObserver) {
        return false;
      }
      if (Object.keys(this.$refs.MessageTemplatesObserver.errors).find(e => e.startsWith('button-') && this.$refs.MessageTemplatesObserver.errors[e].length)) {
        return true;
      }
      return false;
    },
    buttonTypes() {
      const buttonTypes = [
        {
          name: 'None',
          code: null,
        },
        {
          name: 'Reply buttons',
          code: 'buttons',
        },
        {
          name: 'Menu list',
          code: 'menu',
        }];

      if (this.selectedBlock.blockType === 'file') {
        return buttonTypes.filter(bt => bt.code !== 'menu');
      }

      return buttonTypes;
    },
    contentBlocks() {
      return this.blocks.filter(b => b.group === 'content' && !this.hideBlocks.includes(b.text));
    },
    activityBlocks() {
      return this.blocks.filter(b => b.group === 'activity' && !this.hideBlocks.includes(b.text));
    },
    title() {
      return this.selectedBlock ? this.selectedBlock.text : 'Add new block';
    },
    testButtonsTitleError() {
      return Object.keys(this.$refs.MessageTemplatesObserver.errors).some((key) => {
        if (key.startsWith('button-') && this.$refs.MessageTemplatesObserver.errors[key].includes('Each button must have a unique title.')) {
          return true;
        }
        return false;
      }) ? 'Each button must have a unique title.' : false;
    },
    testMenuTitleError() {
      return Object.keys(this.$refs.MessageTemplatesObserver.errors).some((key) => {
        if (key.startsWith('button-') && this.$refs.MessageTemplatesObserver.errors[key].includes('Each menu item must have a unique title.')) {
          return true;
        }
        return false;
      }) ? 'Each menu item must have a unique title.' : false;
    },
  },
  watch: {
    buttonType() {
      if (this.buttonType.code === 'buttons') {
        if (!this.buttons.length) {
          this.addNewButtons();
        } else {
          const targetButton = 'buttonInputRef-0';
          setTimeout(() => {
            this.$refs[targetButton][0].focus();
          }, 0);
        }
      } else if (this.buttonType.code === 'menu') {
        if (!this.menuItems.length) {
          this.addNewMenuItem();
        } else {
          const targetMenuItem = 'menuItemInputRef-0';
          setTimeout(() => {
            this.$refs[targetMenuItem][0].focus();
          }, 0);
        }
      }
    },
    customFieldChange() {
      const currentText = whatsappFormatMessage(this.sendTextContent);
      if (this.customFieldChange.newName) {
        this.$refs.messageArea.setText(currentText.replace(`{{${this.customFieldChange.oldName}}}`, `{{${this.customFieldChange.newName}}}`));
      } else {
        this.$refs.messageArea.setText(currentText.replace(`{{${this.customFieldChange.oldName}}}`, '{{*Deleted tag*}}'));
      }
    },
    uploadedFile(fileData) {
      if (fileData) {
        if (this.editMessage) {
          this.editMessage.text = whatsappFormatMessage(this.fileCaptionContent);
          this.editMessage.url = fileData.file.url;
          this.editMessage.mime_type = fileData.file.mime_type;
          let buttonCode;
          if (this.buttonType.code === 'menu') {
            try {
              buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'List').code;
            } catch {}
            if (buttonCode) {
              this.editMessage.message_type = buttonCode;
              this.editMessage.additional_data = {};
              this.editMessage.additional_data.menu_title = this.menubuttonTitle;
              this.editMessage.additional_data.items = this.generateMenuItemList();
            }
          }
          if (this.buttonType.code === 'buttons') {
            try {
              buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'Quick reply').code;
            } catch {}
            if (buttonCode) {
              this.editMessage.message_type = buttonCode;
              this.editMessage.additional_data = {};
              this.editMessage.additional_data.items = this.generateButtonItemList();
            }
          }
          this.$emit('edit-message');
        } else {
          const message = {
            id: this.editReplyId,
            type: 'file',
            text: whatsappFormatMessage(this.fileCaptionContent).trim(),
            url: fileData.file.url,
            mime_type: fileData.file.mime_type,
            requires_reply: false,
          };
          let buttonCode;
          if (this.buttonType.code === 'menu') {
            try {
              buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'List').code;
            } catch {}
            if (buttonCode) {
              message.message_type = buttonCode;
              message.additional_data = {};
              message.additional_data.menu_title = this.menubuttonTitle;
              message.additional_data.items = this.generateMenuItemList();
            }
          }
          if (this.buttonType.code === 'buttons') {
            try {
              buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'Quick reply').code;
            } catch {}
            if (buttonCode) {
              message.message_type = buttonCode;
              message.additional_data = {};
              message.additional_data.items = this.generateButtonItemList();
            }
          }
          this.$emit('new-message', message);
        }
        this.hide();
      }
    },
    fileUploadError(errorData) {
      this.loading = false;
      if (errorData.error) {
        this.loading = false;
        switch (errorData.error.status) {
          case 422: {
            this.fileErrorMessage = errorData.error.data.errors.file[0];
            break;
          }
          case 413: {
            this.fileErrorMessage = 'File is too big. Max size 16MB.';
            break;
          }
          default: {
            this.fileErrorMessage = 'Something went wrong. Please try again.';
            break;
          }
        }
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      uploadTempFile: 'automation/uploadTempFile',
    }),
    allowedTemplateMessageAttachments,
    addContactReply() {
      this.$emit('new-message', { type: 'reply' });
      this.hide();
    },
    addNewButtons() {
      this.buttons.push({ value: '' });
      const targetButton = `buttonInputRef-${this.buttons.length - 1}`;
      setTimeout(() => {
        this.$refs[targetButton][0].focus();
      }, 0);
    },
    removeOption(index) {
      this.buttons.splice(index, 1);
    },
    addNewMenuItem() {
      this.menuItems.push({ value: '' });
      const targetMenuItem = `menuItemInputRef-${this.menuItems.length - 1}`;
      setTimeout(() => {
        this.$refs[targetMenuItem][0].focus();
      }, 0);
    },
    removeMenuItem(index) {
      this.menuItems.splice(index, 1);
    },
    generateButtonItemList() {
      return this.buttons.map(item => ({ title: item.value })).filter(i => i.title);
    },
    generateMenuItemList() {
      return this.menuItems.map(item => ({ title: item.value })).filter(i => i.title);
    },
    generateButtonsFromMessage(messageAdditionalData) {
      this.buttons = messageAdditionalData.items.map(item => ({ value: item.title }));
    },
    generateListFromMessage(messageAdditionalData) {
      this.menuItems = messageAdditionalData.items.map(item => ({ value: item.title }));
      this.menubuttonTitle = messageAdditionalData.menu_title;
    },
    addSendFile() {
      if (this.formData.has('file')) {
        this.loading = true;
        // First upload file
        this.uploadTempFile({
          businessId: this.businessId,
          message_id: this.editReplyId,
          data: this.formData,
        });
        // Then wait for the uploadedFile to be populated and use the data to save response message
        // Hide the modal from there
      } else {
        this.editMessage.text = whatsappFormatMessage(this.fileCaptionContent).trim();
        let buttonCode;
        if (this.buttonType.code === 'menu') {
          try {
            buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'List').code;
          } catch {}
          if (buttonCode) {
            this.editMessage.message_type = buttonCode;
            this.editMessage.additional_data = {};
            this.editMessage.additional_data.menu_title = this.menubuttonTitle;
            this.editMessage.additional_data.items = this.generateMenuItemList();
          }
        }
        if (this.buttonType.code === 'buttons') {
          try {
            buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'Quick reply').code;
          } catch {}
          if (buttonCode) {
            this.editMessage.message_type = buttonCode;
            this.editMessage.additional_data = {};
            this.editMessage.additional_data.items = this.generateButtonItemList();
          }
        }
        this.$emit('edit-message');
        this.$nextTick(() => {
          this.hide();
        });
      }
    },
    addSendText() {
      if (this.editMessage) {
        this.editMessage.text = whatsappFormatMessage(this.sendTextContent).trim();
        let buttonCode;
        if (!this.buttonType.code) {
          delete this.editMessage.message_type;
          delete this.editMessage.additional_data;
        } else if (this.buttonType.code === 'menu') {
          try {
            buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'List').code;
          } catch {}
          if (buttonCode) {
            this.editMessage.message_type = buttonCode;
            this.editMessage.additional_data = {};
            this.editMessage.additional_data.menu_title = this.menubuttonTitle;
            this.editMessage.additional_data.items = this.generateMenuItemList();
          }
        } else if (this.buttonType.code === 'buttons') {
          try {
            buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'Quick reply').code;
          } catch {}
          if (buttonCode) {
            this.editMessage.message_type = buttonCode;
            this.editMessage.additional_data = {};
            this.editMessage.additional_data.items = this.generateButtonItemList();
          }
        }
        this.$emit('edit-message');
      } else {
        const message = {
          id: this.editReplyId,
          type: 'text',
          text: whatsappFormatMessage(this.sendTextContent).trim(),
          url: null,
          mime_type: null,
          requires_reply: false,
        };
        let buttonCode;
        if (this.buttonType.code === 'menu') {
          try {
            buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'List').code;
          } catch {}
          if (buttonCode) {
            message.message_type = buttonCode;
            message.additional_data = {};
            message.additional_data.menu_title = this.menubuttonTitle;
            message.additional_data.items = this.generateMenuItemList();
          }
        }
        if (this.buttonType.code === 'buttons') {
          try {
            buttonCode = this.waSettings['session-message-buttons'].message_type.find(type => type.name === 'Quick reply').code;
          } catch {}
          if (buttonCode) {
            message.message_type = buttonCode;
            message.additional_data = {};
            message.additional_data.items = this.generateButtonItemList();
          }
        }
        this.$emit('new-message', message);
      }
      this.$nextTick(() => {
        this.hide();
      });
    },
    checkIfCaptionsAreAllowed(fileType) {
      // if (fileType && getMediaType(fileType) === 'image') {
      //   this.captionsAllowed = true;
      // } else {
      //   this.captionsAllowed = false;
      // }

      // buttons on the message require captions so we always show them
      this.captionsAllowed = true;
    },
    fileDropped(files) {
      if (files.length) {
        this.formData.set('file', files[0]);
        // this.captionsAllowed = !!(getMediaType(files[0].type) === 'image');
      } else {
        this.formData.delete('file');
        // this.captionsAllowed = false;
      }
      // buttons on the message require captions so we always show them
      this.captionsAllowed = true;
    },
    showBlock(block) {
      if (!block.hasForm) {
        block.action();
      } else {
        this.selectedBlock = block;
        this.hideFooter = false;
        setTimeout(() => {
          this.populateForm();
        }, 0);
      }
    },
    resetBlockType() {
      this.selectedBlock = null;
      this.hideFooter = true;
      this.editMessage = null;
    },
    show(message = null) {
      if (message && message.id) {
        message.text = findDeletedCustomFelds(message.text);
        this.editMessage = message;
        this.editReplyId = message.id;
        const targetBlock = this.blocks.find(block => block.blockType === message.type);
        this.selectedBlock = targetBlock;
        if (message.message_type === 'QUR') {
          this.buttonType = this.buttonTypes.find(bt => bt.code === 'buttons');
          this.generateButtonsFromMessage(message.additional_data);
        } else if (message.message_type === 'LIS') {
          this.buttonType = this.buttonTypes.find(bt => bt.code === 'menu');
          this.generateListFromMessage(message.additional_data);
        }
        this.checkIfCaptionsAreAllowed(this.editMessage.mime_type);
        this.$nextTick(() => {
          this.populateForm();
        });
      } else {
        this.editReplyId = `temp-${randomString()}`;
      }
      this.$refs.addNewBlockModal.show();
    },
    populateForm() {
      if (
        (this.editMessage && this.editMessage.type === 'text') ||
        (this.selectedBlock && this.selectedBlock.blockType === 'text')
      ) {
        if (this.editMessage) {
          this.$refs.messageArea.setText(`${this.editMessage.text} `); // adding a space at the end because otherwise the cursor is in the tag af tag is the last text element.
        }
        setTimeout(() => {
          this.$refs.messageArea.focusInput();
        }, 0);
      } else if (this.editMessage && this.editMessage.type === 'file') {
        setTimeout(() => {
          if (this.$refs.captionsArea) {
            if (this.editMessage.text) {
              this.$refs.captionsArea.setText(`${this.editMessage.text} `); // adding a space at the end because otherwise the cursor is in the tag af tag is the last text element.
            }
            setTimeout(() => {
              this.$refs.captionsArea.focusInput();
            }, 0);
          }
        }, 0);
      }
    },
    submit(e) {
      e.preventDefault();
      this.selectedBlock.action();
    },
    clear() {
      this.selectedBlock = null;
      // this.captionsAllowed = false;
      this.fileErrorMessage = null;
      this.fileCaptionContent = '';
      this.sendTextContent = '';
      this.editMessage = null;
      this.loading = false;
      this.editReplyId = null;
      this.formData = new FormData();
      this.buttons = [];
      this.menuItems = [];
      this.buttonType = '';
      this.files = [];
    },
    hide() {
      this.$refs.addNewBlockModal.hide();
    },
  },
};
</script>


<style lang="scss">
#add-new-block-modal {
  .modal-header {
    * {
      font-weight: 500 !important;
    }

    .modal-title {
      cursor: default;
      text-transform: none;
    }

    .header-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 7px 11px 7px 8px;
      margin: -7px 0 -7px -11px !important;
      border-radius: 5px;

      .sb-icon {
        transform: rotate(90deg);
        margin-right: 8px;
      }

      &:hover {
        background: #edf0f2;

        .sb-icon .mask {
          background-color: $blackPrimary !important;
        }
      }
    }
  }

  .body-wrapper {
    &.white-bg {
      background-color: $white !important;
    }

    &:last-child {
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    h5 {
      font-size: 14px;
      font-weight: 500;
      color: $blackPrimary;
      margin-bottom: 15px;

      &:not(:first-child) {
        margin-top: 15px;
      }
    }

    .blocks {
      margin: 0 !important;

      .block {
        cursor: pointer;
        display: flex;
        align-items: center;
        border: 1px dashed $greyBorder;
        border-radius: 7px;
        padding: 16px;
        font-weight: 500;

        .sb-icon {
          margin-right: 16px;
        }

        &:nth-child(odd) {
          margin-right: 16px;
        }

        &.col-6 {
          max-width: calc(50% - 8px);
        }

        &:hover {
          background-color: $greyUltralight;

          .sb-icon .mask {
            background-color: $blackPrimary !important;
          }
        }
      }
    }

    .form-group {
      margin-bottom: 0px !important;
    }
  }

  .add-more-btn {
    display: inline-block;
    color: $bluePrimary;
    padding: 0 0 0 0;
    margin-top: 15px;

    span {
      font-weight: 500;
      font-size: 14px;
    }

    &:hover {
      cursor: pointer;
      color: $blackPrimary;
      .sb-icon .mask {
        background-color: $blackPrimary !important;
      }
    }
  }

  .option {
    position: relative;

    .option-item {
      margin-bottom: 10px;
    }

    .delete {
      // display: none;
      position: absolute;
      top: 7px !important;
      right: 7px !important;
      margin-right: 0 !important;
      cursor: pointer;
    }

    .error {
      margin-top: -5px;
      margin-bottom: 10px;
    }

    &:hover {
      .delete {
        display: flex;
      }
    }
  }

  .button-fields {
    .settings__label {
      margin-top: 15px !important;
      font-weight: 400 !important;
    }
  }

  .observer-error {
    margin-top: 15px;
  }

  .form-group label .character-counter,
  .optional {
    font-size: 14px !important;
    font-weight: normal !important;
    color: $blackUltralight !important;
  }
}

.button-description {
  margin-top: 8px;
  line-height: 1.21;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;
}
</style>
